export const scrollToElement = (el: HTMLElement, timeout = 0) => {
  setTimeout(() => {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, timeout);
};
